import { Component, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { DrawerComponent } from '@vg-constellation/angular-18/drawer';
import { PageHelpService } from './page-help.component.service';
import pageHelp from './page-help-content/phc-page-help';

@Component({
  selector: 'page-help',
  templateUrl: './page-help.component.html',
  styleUrls: ['./page-help.component.scss']
})
export class PageHelpComponent implements AfterViewInit {
  readonly CLASSNAME_FOCUS_PANEL_ACTIVE = 'ss-panel--active';
  isFPOpen: boolean = false;
  isPageHelpOpen: boolean = false;

  @ViewChild('pageHelpDrawer') pageHelpDrawer!: DrawerComponent;
  public pageHelp;
  private hasInitialLoadCompleted = false;

  @Output() drawerStateChange = new EventEmitter<{ isDrawerOpen: boolean }>();

  constructor(
    public pageHelpService: PageHelpService,
  ) { }

  ngAfterViewInit() {
    this.pageHelpService.currentDrawerStatus$.subscribe((shouldOpen) => {
      if (this.hasInitialLoadCompleted) {
        function resizePageHelp(vgHeaderHeight: number | null = null) {
          const pageHelpEl = window.document.getElementById("page-help-drawer-container")
          if (+window?.innerWidth < 992) {
            vgHeaderHeight = 0
          } else if (vgHeaderHeight === null) {
            vgHeaderHeight = document?.querySelector("body > app-root > vg-vgn-nav")?.shadowRoot?.querySelector("vg-vgn-header")?.shadowRoot?.querySelector("header")?.clientHeight || 0
          }
          const pageHelpHeight = (+window?.innerHeight - +vgHeaderHeight)
          pageHelpEl.style.height =  `${pageHelpHeight}px`
          pageHelpEl.style.top = `${+vgHeaderHeight}px`
        }       

        const htmlEl = document.documentElement; // seleciona o <html> diretamente

        const observer = new MutationObserver(function(mutationsList) {
          for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              resizePageHelp(document?.querySelector("body > app-root > vg-vgn-nav")?.shadowRoot?.querySelector("vg-vgn-header")?.shadowRoot?.querySelector("header > div:nth-child(3)")?.clientHeight || 0)
            }
          }
        });

        if (shouldOpen) {
          this.isPageHelpOpen = true;
          this.pageHelp = pageHelp[`${this.pageHelpService.currentDrawerType$.value}`];
          this.pageHelpDrawer.openDrawer();
          window.scrollTo({top: 0, behavior: 'smooth'});
          resizePageHelp(null)
          window.addEventListener('resize', ()=>resizePageHelp(null), {passive: true, capture: true}) 
          observer.observe(htmlEl, { attributes: true, attributeFilter: ['style'] });
         
        } else {
          this.isPageHelpOpen = false;
          this.pageHelp = null;
          this.pageHelpDrawer.closeDrawer();
          window.removeEventListener('resize', ()=>resizePageHelp(null), {capture: true})
          observer.disconnect()
        }
      } else {
        this.hasInitialLoadCompleted = true;
      }
    });
  }

  onClickClose() {
    this.pageHelpService.togglePageHelpDrawer();
  }

  drawerStateHandler(event) {
    this.drawerStateChange.emit({ isDrawerOpen: event?.isDrawerOpen });
  }
}
